import React from 'react'
import { IDiscussionContext } from '../../utils/types';


export const DiscussionProvider = React.createContext<IDiscussionContext | null>(null);

